export const ACTION_TYPES = {
  START_LOADING: 'START_LOADING',
  END_LOADING: 'END_LOADING',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
  ARTICLE_DELETED: 'ARTICLE_DELETED',
  SET_LIKE: 'SET_LIKE',
  UNSET_LIKE: 'UNSET_LIKE',
  SET_ARTICLES: 'SET_ARTICLES',
  SET_ARTICLE: 'SET_ARTICLE',
  UPDATE_USER_DATA: 'UPDATE_USER_DATA',
  USER_LOGGED_OUT: 'USER_LOGGED_OUT',
  ARTICLE_CREATED: 'ARTICLE_CREATED',
  ARTICLE_UPDATED: 'ARTICLE_UPDATED',
} as const;

export const {
  START_LOADING,
  END_LOADING,
  SET_ERROR,
  CLEAR_ERROR,
  ARTICLE_DELETED,
  SET_LIKE,
  UNSET_LIKE,
  SET_ARTICLES,
  SET_ARTICLE,
  UPDATE_USER_DATA,
  USER_LOGGED_OUT,
  ARTICLE_CREATED,
  ARTICLE_UPDATED,
} = ACTION_TYPES;

export type ActionConstant = (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES];
